import { useContext } from 'react';
import useSWR from 'swr';
import { AuthContext } from '../context/AuthContext';

export function attendanceInfoKey(apiDomain, accessToken) {
  return accessToken && apiDomain ? [`${apiDomain}/main/attendance`, accessToken] : null;
}

export function useAttendanceInfo() {
  const { API_SERVER_DOMAIN, useAccessToken, fetchWithToken } = useContext(AuthContext);
  const accessToken = useAccessToken();
  return useSWR(attendanceInfoKey(API_SERVER_DOMAIN, accessToken), fetchWithToken);
}
